module.exports = __webpack_public_path__ + "img/sort／phone／Girl@2x.2111dad1.png";